import { COMPARISON_MEASURE_COLUMN_NAME, COMPARISON_TIMESTAMP_COLUMN_NAME } from './features/comparison';
import { MEASURE_COLUMN_NAME, TIMESTAMP_COLUMN_NAME } from './features/metricValue';
import { DateGranularity, EffectiveDefinition } from './models';

const constantEffectiveDefinition: EffectiveDefinition = {
  schema: {
    measure: {
      type: 'number',
      name: MEASURE_COLUMN_NAME,
    },
    timestamp: {
      type: 'datetime',
      name: TIMESTAMP_COLUMN_NAME,
      dateGranularity: DateGranularity.DAY,
    },
    color: {
      type: 'string',
      name: 'color',
    },
    comparisonMeasure: {
      type: 'number',
      name: COMPARISON_MEASURE_COLUMN_NAME,
    },
    comparisonTimestamp: {
      type: 'datetime',
      name: COMPARISON_TIMESTAMP_COLUMN_NAME,
    },
  },
  features: {
    color: {
      column: 'color',
    },
    measure: { column: MEASURE_COLUMN_NAME },
    timestamp: { column: TIMESTAMP_COLUMN_NAME },
    threshold: {
      thresholds: [
        {
          lines: [
            {
              measure: { column: COMPARISON_MEASURE_COLUMN_NAME },
              timestamp: { column: COMPARISON_TIMESTAMP_COLUMN_NAME },
            },
          ],
        },
      ],
    },
  },
};

export const getConstantEffectiveDefinition = (): EffectiveDefinition => {
  return constantEffectiveDefinition;
};

export const testEffectiveDefinition = getConstantEffectiveDefinition();

const constantSingleNumberEffectiveDefinition: EffectiveDefinition = {
  schema: {
    measure: {
      type: 'number',
      name: MEASURE_COLUMN_NAME,
    },
    timestamp: {
      type: 'datetime',
      name: TIMESTAMP_COLUMN_NAME,
      dateGranularity: DateGranularity.DAY,
      isSnapshotTimestamp: true,
      isTimeless: true,
    },
    color: {
      type: 'string',
      name: 'color',
    },
    comparisonMeasure: {
      type: 'number',
      name: COMPARISON_MEASURE_COLUMN_NAME,
    },
    comparisonTimestamp: {
      type: 'datetime',
      name: COMPARISON_TIMESTAMP_COLUMN_NAME,
    },
  },
  features: {
    color: {
      column: 'color',
    },
    measure: { column: MEASURE_COLUMN_NAME },
    timestamp: { column: TIMESTAMP_COLUMN_NAME },
    threshold: {
      thresholds: [
        {
          lines: [
            {
              measure: { column: COMPARISON_MEASURE_COLUMN_NAME },
              timestamp: { column: COMPARISON_TIMESTAMP_COLUMN_NAME },
            },
          ],
        },
      ],
    },
  },
};

export const getConstantSingleNumberEffectiveDefinition = (): EffectiveDefinition => {
  return constantSingleNumberEffectiveDefinition;
};

export const testSingleNumberEffectiveDefinition = getConstantSingleNumberEffectiveDefinition();
